/** Paths handled by the react app */
export const reactPaths = {
  home: '/',
  login: '/login', // legacy: /login, /login?password_expired, /login?account_expired, /login?locked, /login?disabled
  acceptances: '/acceptances',
  invoices: '/invoices',
  invoicesModule: '/invoices/:tab',
  invoicesForm: '/invoices/:tab/new',
  invoiceDetails: '/invoices/:tab/:invoiceType/:invoiceId', // legacy: invoices/:tab:/:params:/:invoiceId:
  rates: '/rates',
  ratesModule: '/rates/:tab',
  ratesForm: '/rates/:tab/new',
  ratesDetails: '/rates/:tab/:ratesType/:ratesId',
  transportCloud: '/cloud',
  transportCloudForm: '/cloud/new',
  mapping: '/mapping',
  mappingModule: '/mapping',
  mappingForm: '/mapping/new',
  mappingServiceDetails: '/mapping/:serviceId',
} as const;

// NOTE: `*` used for legacy app routes to match all it's nested routes

/** Paths immediately redirected to a different route */
export const redirectPaths = {
  reports: '/reports/*',
  files: '/files/*',
  tables: '/tables/*',
  prices: '/prices/*',
  events: '/events/*',
  admin: '/admin/*',
  settings: '/settings/*',
} as const;

/** Paths handled by the (legacy)iframe app */
export const iframePaths = {
  clientRequests: '/requestsForOffers/*', // legacy: requestsForOffers/:params:
  clientOrders: '/orders/*', // legacy: orders/:params:
  offers: '/offers/*', // legacy: offers/:params:
  jobs: '/jobs/*', // legacy: jobs/:params:
  account: '/account', // legacy: account

  reportsTab: '/reports/:tab/*', // legacy: reports/:tab:/:params:
  filesTab: '/files/:tab/*', // legacy: files/:tab:/:params:
  tableTab: '/tables/:tab/*', // legacy: tables/:tab:/:params:
  pricesTab: '/prices/:tab/*', // legacy: prices/:tab:/:params:
  eventsTab: '/events/:tab/*', // legacy: events/:tab:/:params:
  adminTab: '/admin/:tab/*', // legacy: admin/:tab:/:params:
  settingsTab: '/settings/:tab/*', // legacy: settings/:tab:/:params:
} as const;

// NOTE: They must be ordered (reason to use Map) from least specific to the most specific, for the router to match them correctly.
/** All Navbar routes */
export const navbarPathsMap = new Map([
  ['home', reactPaths.home],
  ['invoices', reactPaths.invoices + '/*'], // `*` used here to match in tabs all invoice routes
  ['rates', reactPaths.rates + '/*'], // `*` used here to match in tabs all rates routes
  ['reports', redirectPaths.reports],
  ['files', redirectPaths.files],
  ['tables', redirectPaths.tables],
  ['prices', redirectPaths.prices],
  ['events', redirectPaths.events],
  ['admin', redirectPaths.admin],
  ['settings', redirectPaths.settings],
  ['clientRequests', iframePaths.clientRequests],
  ['clientOrders', iframePaths.clientOrders],
  ['offers', iframePaths.offers],
  ['jobs', iframePaths.jobs],
  ['account', iframePaths.account],
  ['transportCloud', reactPaths.transportCloud + '/*'], // `*` used here to match in tabs all transport cloud routes
  ['mapping', reactPaths.mapping + '/*'], // `*` used here to match in tabs all mapping routes
] as const);

export const navbarRoutesList = Array.from(navbarPathsMap.values()).reverse();
